import {useMutation, gql} from '@apollo/client'

const MUTATE_DATA = gql`
  mutation MUTATE_DATA(
    $groupId: Int!
    $groupName: Customname!
    $jurisdiction: [Int]
    $dataAggregation: [Int]
    $filters: [String]
    $description: AlphanumericOrEmpty
    $trendAnalysisFlag: [Int]
    $chatbotFlag: [Int]
    $chatbotExportFlag: [Int]
    $chatbotCopyFlag: [Int]
    $exportFlag: [Int]
    $benefits: [Int]
    $workforces: [Int]
    $usecase: [Int]
    $pointOfInterest: [Int]
    $personaFlag: [Int]
  ) {
    updateGroup(
      groupId: $groupId
      groupName: $groupName
      jurisdiction: $jurisdiction
      dataAggregation: $dataAggregation
      filters: $filters
      description: $description
      trendAnalysisFlag: $trendAnalysisFlag
      chatbotFlag: $chatbotFlag
      exportFlag: $exportFlag
      benefits: $benefits
      workforces: $workforces
      usecase: $usecase
      pointOfInterest: $pointOfInterest
      personaFlag: $personaFlag
      chatbotExportFlag: $chatbotExportFlag
      chatbotCopyFlag: $chatbotCopyFlag
    ) {
      userGroup {
        group_name
        group_type
        group_id
        client_id
        description
        filters
        data_aggregation
        jurisdiction
        is_completed
        trend_analysis_flag
        chatbot_flag
        export_flag
        benefits
        workforces
        usecase
        point_of_interest
        persona_flag
        chatbot_export_flag
        chatbot_copy_flag
      }
    }
  }
`

export function useUpdateProjectDetails() {
  return useMutation(MUTATE_DATA, {
    context: {clientName: 'adminPanel'}
  })
}
